export var LegacySubscriptionStatus = /*#__PURE__*/function (LegacySubscriptionStatus) {
  LegacySubscriptionStatus["ACTIVE"] = "active";
  LegacySubscriptionStatus["PENDING_PAUSE"] = "pendingPause";
  LegacySubscriptionStatus["PAUSED"] = "paused";
  LegacySubscriptionStatus["PENDING_CANCEL"] = "pendingCancel";
  LegacySubscriptionStatus["CANCELLED"] = "cancelled";
  LegacySubscriptionStatus["EXPIRED"] = "expired";
  return LegacySubscriptionStatus;
}({});
export var LegacyCatalogItemType = /*#__PURE__*/function (LegacyCatalogItemType) {
  LegacyCatalogItemType["ONE_TIME"] = "ONE_TIME_ITEM";
  LegacyCatalogItemType["FIXED_RECURRING_ITEM"] = "FIXED_RECURRING_ITEM";
  LegacyCatalogItemType["RECURRING_BUNDLE_ITEM"] = "RECURRING_BUNDLE_ITEM";
  return LegacyCatalogItemType;
}({});
export var LegacyProductFamily = /*#__PURE__*/function (LegacyProductFamily) {
  LegacyProductFamily["CHEGG_STUDY"] = "CHEGG_STUDY";
  LegacyProductFamily["CHEGG_STUDY_PACK"] = "BUNDLE";
  LegacyProductFamily["EASYBIB"] = "EASYBIB";
  LegacyProductFamily["BIBME"] = "BIBME";
  LegacyProductFamily["CTFM"] = "CTFM";
  LegacyProductFamily["CITATIONMACHINE"] = "CITATIONMACHINE";
  return LegacyProductFamily;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/SubscriptionUtil/interface/LegacyMyLatestSubscriptionsWithDates.js
// module id = 1432
// module chunks = 11